import { Component } from '@angular/core';

@Component({
  selector: 'app-about-lilly',
  templateUrl: './about-lilly.component.html',
  styleUrls: ['./about-lilly.component.less'],
})
export class AboutLillyComponent {

}
